import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=b35a6546&scoped=true"
import script from "./Price.vue?vue&type=script&lang=ts"
export * from "./Price.vue?vue&type=script&lang=ts"
import style0 from "./Price.vue?vue&type=style&index=0&id=b35a6546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35a6546",
  null
  
)

export default component.exports